import { useState, useRef } from "react";
import { gtmPush } from "../../functions/gtm";
import TextField from "../../audi-ui-components/TextField";
import Select from "../../audi-ui-components/Select";
import Button from "../../audi-ui-components/Button";
import Modal from "../../audi-ui-components/Modal";
import VINHelp from "../../components/VINHelp";
import { STATES_OPTIONS, DEFAULT_THEME } from "../../constants";

const StepVin = ({ values, errors, touched, setFieldValue, setFieldTouched, theme = DEFAULT_THEME }) => {
  //
  const [showVinHelp, setShowVinHelp] = useState(false);
  const hasTrackedVin = useRef(false);
  const hasTrackedRego = useRef(false);
  const hasTrackedState = useRef(false);

  return (
    <div className="vehiclesearch">
      <p className="mb-3">If you've disposed of your vehicle, updated your personal details or your Audi has been written off, we'll take care of you.</p>
      <p className="mb-5 pb-medium-3">Enter your vehicle details, complete the form and we'll handle the rest.</p>
      <p className="aui-headline-4 mb-3 d-none d-medium-block">Your vehicle details</p>
      <TextField name="vin"
        label="Enter your VIN"
        value={values.vin}
        onChange={(v) => { setFieldValue('vin', v); }}
        onBlur={() => { setFieldTouched('vin'); }}
        onFocus={() => { if(!hasTrackedVin.current) {
          gtmPush("cvoVinEntered", "ChangeVehicleOwnership");
          hasTrackedVin.current = true;
        }}}
        isInvalid={errors.vin && touched.vin}
        invalidMessage={errors.vin}
        description={
          <>Unique 17-character vehicle identification number <Button onClick={()=>{setShowVinHelp(true); }} theme={theme === "dark" ? "light" : null}>ⓘ</Button></>
        }
        className="form-field"
        theme={theme === "dark" ? "light" : null}
      />
      <div className="or aui-headline-5"><span>OR</span></div>
      <TextField name="rego"
        label="Enter your registration number"
        value={values.rego}
        onChange={(v) => { setFieldValue('rego', v); }}
        onBlur={() => { setFieldTouched('rego'); }}
        onFocus={() => { if(!hasTrackedRego.current) {
          gtmPush("cvoRegistrationEntered", "ChangeVehicleOwnership");
          hasTrackedRego.current = true;
        }}}
        isInvalid={errors.rego && touched.rego}
        invalidMessage={errors.rego}
        className="form-field"
        theme={theme === "dark" ? "light" : null}
      />
      <Select name="regoState"
        label="State"
        options={STATES_OPTIONS}
        value={values.regoState}
        onChange={(v) => {
          setFieldValue('regoState', v);
          if(!hasTrackedState.current) {
            gtmPush("cvoStateSelected", "ChangeVehicleOwnership", v);
            hasTrackedState.current = true;
          }
        }}
        onBlur={() => { setFieldTouched('regoState'); }}
        isInvalid={errors.regoState && touched.regoState}
        invalidMessage={errors.regoState}
        className="form-field"
        theme={theme === "dark" ? "light" : null}
      />
      <Modal variant="layer" isActive={showVinHelp} closeButton close={()=>{ setShowVinHelp(false); }}>
        <VINHelp />
      </Modal>
    </div>
  );
};

export default StepVin;
